export const SquareInSquareIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="31"
      height="25"
      viewBox="0 0 31 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3679 14.8672H24.366C24.7267 14.8672 25.0299 14.7445 25.2754 14.499C25.5209 14.2535 25.6436 13.9504 25.6436 13.5896V6.0915C25.6436 5.73075 25.5209 5.42762 25.2754 5.18212C25.0299 4.93662 24.7267 4.81387 24.366 4.81387H18.3679C18.0071 4.81387 17.704 4.93662 17.4585 5.18212C17.213 5.42762 17.0902 5.73075 17.0902 6.0915V13.5896C17.0902 13.9504 17.213 14.2535 17.4585 14.499C17.704 14.7445 18.0071 14.8672 18.3679 14.8672ZM2.55487 24.4575C1.86487 24.4575 1.26663 24.2041 0.760125 23.6974C0.253375 23.1909 0 22.5926 0 21.9026V2.56387C0 1.87137 0.253375 1.271 0.760125 0.762749C1.26663 0.254249 1.86487 0 2.55487 0H27.8936C28.5861 0 29.1865 0.254249 29.6947 0.762749C30.2032 1.271 30.4575 1.87137 30.4575 2.56387V21.9026C30.4575 22.5926 30.2032 23.1909 29.6947 23.6974C29.1865 24.2041 28.5861 24.4575 27.8936 24.4575H2.55487ZM2.55487 21.9026H27.8936V2.56387H2.55487V21.9026Z"
        fill="currentColor"
      />
    </svg>
  );
};
